// Wire contract of POST {bff}/api/productidentification — the backend's
// GtinIdentificationRequest requires 'gtin' (a 'code' property is rejected 400 since
// required-member enforcement; the historic drift broke web identify silently).
export class IdentifyProductRequest {
  constructor(gtin: string) {
    this.gtin = gtin;
  }
  gtin: string;
}
